/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import MomSysOrderBuyerDetailButton from "../input/MomSysOrderBuyerDetailButton";
import MomSysBusinessDetailDeleteButton from "../input/MomSysBusinessDetailDeleteButton";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import SaveToExcelButton from "../input/SaveToExcelButton";
import MomSysOrderBuyerDetailUpdateButton from "../input/MomSysOrderBuyerDetailUpdateButton";
import MomSysOrderBuyerDetailImgUpdateButton from "../input/MomSysOrderBuyerDetailImgUpdateButton";
import { cloneDeep, debounce } from "lodash";
import defineConf from "../../config/defineConf";

function MomSysUglOrderBuyerDetail ( props ) {

    const {
        id,
        onSelectMst,
        onDetailEmpty,
        onSelectDetailData,
    } = props;

    const { t } = useTranslation ();

    const [ grid, setGrid ] = useState();

    const [ onSelectDetail, setOnSelectDetail ] = useState();

    const [ tableSchema, setTableSchema ] = useState();

    const [ isEmpty, setIsEmpty ] = useState();

    const [ detailApi, setDetailApi ] = useState();

    const [ , setNotification ] = useRecoilState(notificationState);
    
    useEffect ( () => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("MomSysUglOrderBuyerDetail");

            if ( mounted ) {

                for (const column of schema.columns) {
    
                    switch (column.name) {
        
                    case "orderBuyerId":
        
                        column.defaultValue = onSelectMst.orderBuyerId;
                        column.disabled = true;
        
                        break;
        
                    default:
        
                        break;
                    }
                }

                schema.columns.push ( 
                    { 
                        name: "modelName", 
                        disabled : true,
                        formGroup : 0,
                        formOrder : 31,
                        formItemType : "text",
                    },
                    { 
                        name: "modelPartName", 
                        disabled : true,
                        formGroup : 0,
                        formOrder : 32,
                        formItemType : "text",
                    },
                    { 
                        name: "itemSpecName", 
                        disabled : true,
                        formGroup : 0,
                        formOrder : 33,
                        formItemType : "text",
                    },
                    { 
                        name: "itemUnitName", 
                        disabled : true,
                        formGroup : 0,
                        formOrder : 34,
                        formItemType : "text",
                    },
                    { 
                        name: "standard", 
                        disabled : true,
                        hideInForm : true,
                        formGroup : 0,
                        formOrder : 35,
                        formItemType : "text",
                    },
                );
        
                setTableSchema(schema);
    
            }
    
        } ) ();

        return ( () => {
            mounted = false;
        } );

    }, [] )

    useEffect ( () => {

        if ( detailApi ) {

            detailApi.refresh ();

        }

    }, [onSelectMst.orderBuyerId] )

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        onSelectDetailData(grid.selectedItems[0]);

                        setOnSelectDetail(grid.selectedItems[0]);

                    } else {

                        onSelectDetailData([]);

                        setOnSelectDetail([]);

                    };

                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        onSelectDetailData(grid.selectedItems[0]);

                        setOnSelectDetail(grid.selectedItems[0]);

                    } else {

                        onSelectDetailData([]);

                        setOnSelectDetail([]);

                    };

                }), 10);
            }

        })()

    }, [grid])

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );
        
        setDetailApi ( ( api ) => {

            if ( api ) {

                api.refresh ();

            }

            return api;

        } );

    };

    const notifyFailure = (msg) => {
    
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };

    const onFailure = ( reason ) => {
    
        notifyFailure ( reason.response ? reason.response.data : reason );
    
    };

    const notifyWarning = (msg) => {
        
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onPartialFailure = ( msg ) => {

        notifyWarning ( msg );

        setDetailApi ( ( api ) => {

            if ( api ) {

                api.refresh ();

            }

            return api;

        } );

    };
    
    const onModifyUrl = ( url, orderBuyerId ) => {

        return url + "/" + orderBuyerId;

    };

    const onInitialized = (grid) => {

        setGrid(grid);
    
    };

    const onLoadData = (data) => {

        let isEmpty = data.length < 1 ? true : false;

        setIsEmpty(isEmpty);

        onDetailEmpty(isEmpty);

    };

    const onApiInitialized = ( api ) => {

        setDetailApi ( api );

    };

    const onDialogUpdateDetail = () => {

        setDetailApi ( ( api ) => {

            if ( api ) {

                api.refresh ();

            }

            return api;

        } );

    }

    const doHandleBackendErrorMsg = (reason) => {
        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;
    
    }

    const onChangeStandardSchema = ( schema, standard ) => {

        let clonedSchema = cloneDeep ( schema );

        if ( standard ) {

            for (const column of clonedSchema.columns) {
        
                switch (column.name) {

                    case "partNo":
                    case "partSeq":
                    case "cutCode1":
                    case "cutCode2":
                    case "material":

                        column.required = false;
                        column.disabled = true;
                        column.formGroup = 0;
                        column.formOrder = 40;

                        break;

                    case "t_size":
                    case "w_size":
                    case "l_size":
                    case "t_delta":
                    case "w_delta":
                    case "l_delta":
                    case "t_grinding":
                    case "w_grinding":
                    case "l_grinding":

                        column.required = false;
                        column.hideInForm = true;

                        break;

                    case "qty":

                        column.disabled = false;
                        column.formGroup = 1;

                        break;

                    case "modellingFile":

                        column.hideInForm = true;

                        break;

                    default:

                        break;
                }

            }

        } else {

            for (const column of clonedSchema.columns) {
        
                switch (column.name) {

                    case "partNo":
                    case "partSeq":
                    case "cutCode1":
                    case "cutCode2":
                    case "material":

                        column.required = true;
                        column.disabled = false;
                        column.formGroup = 1;
                        column.formOrder = 100;

                        break;

                    case "t_size":
                    case "w_size":
                    case "l_size":
                    case "t_delta":
                    case "w_delta":
                    case "l_delta":
                    case "t_grinding":
                    case "w_grinding":
                    case "l_grinding":

                        column.required = true;
                        column.hideInForm = false;

                        break;

                    case "qty":

                        column.disabled = true;
                        column.formGroup = 0;

                        break;

                    case "modellingFile":

                        column.hideInForm = false;

                        break;

                    default:
        
                        break;
                }
    
            }

        }

        return clonedSchema;

    }
    
    const modifyFormDataCallback = ( formData, name, value ) => {

        if ( name === "partNo" ) {

            formData.materialName = formData.modelName + "/" + formData.modelPartName + "/" + value + "/" + formData.partSeq;

        } else if ( name === "partSeq" ) {

            formData.materialName = formData.modelName + "/" + formData.modelPartName + "/" + formData.partNo + "/" + value;

        }

    }

    const onAppendButtonInFrontOfSearch = () => {

        return (
            
            <BasicCrudScreenActionItemLayout>
                <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod="POST">
                    
                    <MomSysOrderBuyerDetailButton
                        id={id}
                        schema={tableSchema}
                        onSuccess = {onNotifySuccess}
                        onDialogUpdateDetail={onDialogUpdateDetail}
                        onSelectMst={onSelectMst}
                        customizeErrorMsgCallback={doHandleBackendErrorMsg}
                        onChangeStandardSchema={onChangeStandardSchema}
                        modifyFormDataCallback={modifyFormDataCallback}
                    />
                </AccessControl>
        
                {
                    !onSelectMst?.approvalState
                    ?
                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod={tableSchema && (tableSchema.updateWithPatch?"PATCH":"PUT")}>
                        <MomSysOrderBuyerDetailUpdateButton
                            id = {id}
                            schema = {tableSchema}
                            grid ={grid}
                            onSuccess ={onNotifySuccess}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                            onChangeStandardSchema={onChangeStandardSchema}
                            modifyFormDataCallback={modifyFormDataCallback}
                            disabled={onSelectMst?.approvalState || isEmpty}
                        />
                    </AccessControl>
                    :
                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod={tableSchema && (tableSchema.updateWithPatch?"PATCH":"PUT")}>
                        <MomSysOrderBuyerDetailImgUpdateButton
                            id = {id}
                            schema = {tableSchema}
                            grid ={grid}
                            onSuccess ={onNotifySuccess}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                            onChangeStandardSchema={onChangeStandardSchema}
                            modifyFormDataCallback={modifyFormDataCallback}
                            disabled={
                                [defineConf.approvalState.REJECTED, defineConf.approvalState.WITHDRAWN, defineConf.approvalState.CANCELLED].includes(onSelectMst?.approvalState) 
                                || isEmpty
                            }
                        />
                    </AccessControl>
                }
        
                <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod="DELETE">
                    <MomSysBusinessDetailDeleteButton
                        id = {id}
                        schema = {tableSchema}
                        grid = {grid}
                        color = "secondary"
                        onSuccess = {onNotifySuccess}
                        onFailure={onFailure}
                        onPartialFailure={onPartialFailure}
                        disabled = {onSelectMst?.approvalState || isEmpty}
                    />
                </AccessControl>

                <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod="SAVETOEXCEL">
                    <SaveToExcelButton
                        id={id}
                        grid={grid}
                        view="MomSysZvwOrderBuyerDetail" 
                        color="primary"
                        exportFormatItem={() => {}}
                        disabled={isEmpty}
                    />
                </AccessControl>
            </BasicCrudScreenActionItemLayout>
    
        );
    };

    return (
    
        <BasicCrudScreenType 
            id={id}
            headerTitle={t("term.soDetail")}
            table="MomSysUglOrderBuyerDetail" 
            view="MomSysZvwOrderBuyerDetail" 
            onApiInitialized={onApiInitialized}
            onModifyViewUrl={( url ) => onModifyUrl ( url, onSelectMst.orderBuyerId )}
            onInitialized = {onInitialized}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
            noCreate
            noEdit
            noDelete
            noExcel
            onLoadData={onLoadData}
        />
    
    );

}

export default MomSysUglOrderBuyerDetail;
